import { ViewMode } from '../constants';
import { get, post, put, remove as httpRemove } from '../Services/http';
import { catchError } from './Error.action';
import {
  FIND_MY_PART_RECEIVE,
  FIND_MY_PART_ERROR,
  FIND_MY_PART_CHANGE_MODE,
  FIND_MY_PART_RECEIVE_OPTIONS,
  FIND_MY_PART_RECEIVE_SEGMENTS,
  FIND_MY_PART_RECEIVE_SEARCH_ITEMS,
  PRODUCT_CONFIGURATOR_RECEIVE,
  PRODUCT_CONFIGURATOR_SEND,
  PRODUCT_CONFIGURATOR_UPDATE,
  PRODUCT_CONFIGURATOR_BUTTON_STATUS,
} from '../constants';
const rootRoute = '/api/findmypart';

const stateStyles = {
  LOADING: '--loading',
  SUCCESS: '--success',
  ERROR: '--error',
};

export const changeMode = (mode) => ({
  type: FIND_MY_PART_CHANGE_MODE,
  payload: {
    mode,
  },
});

export const getSearchItems = () => (dispatch) => {
  return get(rootRoute + '/getSearchItems')
    .then((response) => response.json())
    .then((result) => {
      dispatch(receiveSearchItems(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const getSegments = (options) => (dispatch) => {
  return get(rootRoute + '/getSegments', options)
    .then((response) => response.json())
    .then((result) => {
      dispatch(receiveSegments(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};
export const getOptions = (
  options,
  decorateUrl = false,
  skipReload = false,
  selectedVariantId = null
) => (dispatch) => {
  return post(rootRoute + '/getOptions', options)
    .then((response) => response.json())
    .then((result) => {
      dispatch(
        receiveFmpOptions(
          result,
          options.optionsGeneral || options.optionsPsg,
          decorateUrl,
          skipReload,
          selectedVariantId
        )
      );
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const optimizeSearch = (options) => (dispatch) => {
  return post(rootRoute + '/optimizeProductsGeneral', options)
    .then((response) => response.json())
    .then((result) => {
      dispatch(generalOptimizedDataResult(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const getMiniFmpOptions = (pId) => (dispatch) => {
  return get(rootRoute + '/getMiniFmpOptions?productId=' + pId)
    .then((response) => response.json())
    .then((result) => {
      dispatch(receiveMiniFmpOptions(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

const receiveSegments = (segments) => ({
  type: FIND_MY_PART_RECEIVE_SEGMENTS,
  payload: {
    segments,
  },
});
const receiveSearchItems = (searchItems) => ({
  type: FIND_MY_PART_RECEIVE_SEARCH_ITEMS,
  payload: {
    searchItems,
  },
});

const insertUrlParam = (key, value) => {
  if (history.pushState) {
    const url = new URL(window.location);
    url.searchParams.set(key, value);
    window.history.pushState(null, '', url.toString());
  }
};

export const removeUrlParameter = (paramKey) => (dispatch) => {
  const url = window.location.href;
  const updatedUrl = new URL(url);
  updatedUrl.searchParams.delete(paramKey);
  const newUrl = updatedUrl.href;
  window.history.pushState({ path: newUrl }, '', newUrl);
};

export const toggleUrlVal = (key, value, remove = false) => (dispatch) => {
  if (value) {
    insertUrlParam(key, value);
  } else {
    dispatch(removeUrlParameter(key));
  }
};

const receiveFmpOptions = (
  response,
  options,
  decorateUrl = false,
  skipReload = false,
  selectedVariantId = null
) => (dispatch) => {
  const urlParams = new URLSearchParams(window.location.search);
  const complete = urlParams.get('f');
  if (response.variantItems?.length > 0 && !skipReload) {
    let url = null;
    if (response.variantItems.length === 1) {
      url = response.variantItems[0].url;
    } else if (selectedVariantId) {
      let selectedVariantObj = response.variantItems.find(
        (x) => x.id === selectedVariantId
      );
      url = selectedVariantObj?.url;
    }
    if (!url) {
      url = response.variantItems[0].url;
    }
    if (url) {
      window.location.replace(url);
    }
  }

  dispatch(receiveOptions(response));
  if (decorateUrl) {
    if (options) {
      const brand = options.brand?.value;
      dispatch(toggleUrlVal('brand', brand));

      const model = options.model?.value;
      dispatch(toggleUrlVal('model', model));

      const year = options.year?.value;
      dispatch(toggleUrlVal('year', year));
    }
  }
};

const receiveMiniFmpOptions = (response) => (dispatch) => {
  dispatch(receiveOptions(response));
  dispatch(receiveSearchItems(response.searchItems));
};

const receiveOptions = (request) => ({
  type: FIND_MY_PART_RECEIVE_OPTIONS,
  payload: {
    options: request.options,
    variantItems: request.variantItems,
  },
});
const receive = (list) => ({
  type: FIND_MY_PART_RECEIVE,
  payload: {
    list,
  },
});

export const setError = (error) => ({
  type: FIND_MY_PART_ERROR,
  payload: {
    error,
  },
});

const generalOptimizedDataResult = (result) => {
  const optimizedContainerId = 'search-result';
  //const optimizedContainerClassName = 'search-result';
  const dom = result?.productsView;

  if ([null, undefined].includes(dom)) {
    return;
  }

  const optimizedData = document.createElement('div');
  optimizedData.id = optimizedContainerId;
  //optimizedData.classList = optimizedContainerClassName;
  optimizedData.innerHTML = dom;
  const optimizedDataResult = document.querySelector(
    '#' + optimizedContainerId
  );
  const tempResult = optimizedData.querySelector('#' + optimizedContainerId);
  const replace = (node, newNode) =>
    node.parentNode.replaceChild(newNode, node);
  // replace existingResult with tempResult ( container )
  replace(optimizedDataResult, tempResult);
  // bootstrap react components if any exists in the search result
  window.__litium.bootstrapComponents();
};

export const getVariantData = (options) => (dispatch) => {
  return post(rootRoute + '/getVariantData', options)
    .then((response) => response.json())
    .then((result) => {
      dispatch(receiveVariantData(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const updatingSelectedData = (options) => (dispatch) => {
  const sendOptions = getSendObject(options, '');
  return post(rootRoute + '/updateOptions', sendOptions)
    .then((response) => response.json())
    .then((result) => {
      dispatch(responseUpdatingVariantData(result));
    })
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          setError(error);
        })
      )
    );
};

export const setVariantData = (options, userText) => (dispatch) => {
  dispatch(uppdateButtonStatus(stateStyles.LOADING));
  const sendOptions = getSendObject(options, userText);
  return post(rootRoute + '/sendOptions', sendOptions)
    .then((response) => response.json())
    .then((result) => {
      dispatch(responseSetVariantData(result));
    })
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          setError(error);
        })
      )
    );
};

const getSendObject = (options, userText) => {
  const items = [];
  options.items.map((item) => {
    const selectedData = {
      title: item.title,
      selectedData: item.variantData.find((y) => y.selected === true),
    };
    items.push(selectedData);
  });
  return {
    articleNo: options.articleNo,
    items,
    message: userText,
  };
};

const receiveVariantData = (variantData) => ({
  type: PRODUCT_CONFIGURATOR_RECEIVE,
  payload: {
    variantData,
  },
});

export const responseSetVariantData = (response) => (dispatch) => {
  dispatch(uppdateButtonStatus(stateStyles.SUCCESS));
  dispatch(loadCart());
  setTimeout(() => {
    dispatch(uppdateButtonStatus(''));
  }, 1400);
  dispatch({
    type: PRODUCT_CONFIGURATOR_SEND,
    payload: {
      returnMessage: response.message,
    },
  });
};

export const uppdateButtonStatus = (btnStatus) => (dispatch) => {
  dispatch({
    type: PRODUCT_CONFIGURATOR_BUTTON_STATUS,
    payload: {
      buyButtonStatusClass: btnStatus,
    },
  });
};

export const responseUpdatingVariantData = (response) => (dispatch) => {
  dispatch({
    type: PRODUCT_CONFIGURATOR_UPDATE,
    payload: {
      configMessage: response.message,
    },
  });
};
